export default __webpack_public_path__ + "static/media/pot4.576dfaf6.jpg";